/**
 * Checks if a multi select list item is selected.
 * @param item to check if it is selected
 * @param selectedItems MultiSelectSecurityListItem[] of the currently selected items
 * @param activeSecurityGroupTab currently selected tab in the multi security list selector modal
 * @returns boolean whether or not the given item is selected
 */
export const isMultiSelectListItemSelected = function (item, selectedItems, activeSecurityGroupTab) {
    // Check the current security group as well as the selected item. This helps differentiate security lists
    // that have the same name on two different tabs: For example,
    // Equities > Styles > Large Cap / Blend vs Funds > Styles > Large Cap / Blend
    return selectedItems.some((selectedItem) => selectedItem.item.key === item.key && selectedItem.group === activeSecurityGroupTab);
};
